module.exports = __webpack_public_path__ + "img/signup-teacher-type.34f09b52.svg";